/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { counterTheme, counterSize } from './styles'

const Counter = ({ value, size, theme, className, onClick, clickable = false, mode = 'light' }) => {
  const isClickable = !!onClick || clickable
  return (
    <span
      className={cx(styles.counter, className, counterSize(size), counterTheme(theme, isClickable, mode), isClickable && styles.clickable)}
      onClick={onClick}
      tabIndex={onClick ? '0' : '-1'}>
      {value}
    </span>
  )
}

Counter.propTypes = {
  value: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'medium']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  clickable: PropTypes.bool,
  mode: PropTypes.oneOf(['', 'light', 'dark']),
}

Counter.defaultProps = {
  theme: 'primary',
  size: 'default',
  mode: 'light',
}

export default Counter
